import React from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import ENUMS from '../../../enums';
import * as cafeDiscountActions from '../../../redux/cafeDiscounts/actions';
import Spin from '../../../components/loading';
import CafeDiscountRequestDetails from './modals/cafeDiscountRequestDetails';
import ShowForPermission from '../../../components/ShowForPermission';
import { enumHelper } from '../../../utils';
import generateClassName from '../../../utils/generateClassName';

class CafeDiscountRequestsTable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      cafeDiscountRequestOpen: false,
      sortType: 'asc',
      selectedCafeDiscountRequestId: null,
      status: '',
      isActive: false,
      sortedColumn: '',
    };
  }

  sortTable = query => {
    this.setState({ sortedColumn: query });
    this.props.sortTable(query);
  };

  renderStatusColors = status => {
    const { CONFIRMED, REJECTED, REQUESTED } = ENUMS.CAFE_DISCOUNT_STATUS.values;
    switch (status) {
      case REQUESTED:
        return 'text-warning';
      case CONFIRMED:
        return 'text-success';
      case REJECTED:
        return 'text-danger';
      default:
        return 'text-dark';
    }
  };

  displayCafeDiscountRequestModal = id => {
    let { cafeDiscountRequestsList, cafeDiscountRequestArchivesList } = this.props;
    let selectedCafeDiscountRequestId = (this.props.fromArchive
        ? cafeDiscountRequestArchivesList
        : cafeDiscountRequestsList
    ).filter(request => request.id == id)[0].id;
    this.setState({ cafeDiscountRequestOpen: true, selectedCafeDiscountRequestId });
  };

  closeCafeDiscountRequestModal = () => {
    this.setState(() => ({
      cafeDiscountRequestOpen: false,
    }));
  };

  render() {
    let {
      cafeDiscountRequestsList = [],
      pageSize,
      pageNumber,
      sortType,

      cafeDiscountRequestsLoading,
      cafeDiscountRequestsMessage,
      cafeDiscountRequestsError,
      cafeDiscountRequestsFailed,

      cafeDiscountRequestArchivesLoading,
      cafeDiscountRequestArchivesMessage,
      cafeDiscountRequestArchivesList,
      cafeDiscountRequestArchivesError,
      cafeDiscountRequestArchivesFailed,
    } = this.props;
    return (
      <>
        <Spin spinning={cafeDiscountRequestsLoading || cafeDiscountRequestArchivesLoading}>
          {(cafeDiscountRequestsError || cafeDiscountRequestArchivesError) && (
            <div className="alert alert-danger">{locales('messages.server.error')}</div>
          )}
          {(cafeDiscountRequestsFailed || cafeDiscountRequestArchivesFailed) && (
            <div className="alert alert-danger">
              {cafeDiscountRequestsMessage || cafeDiscountRequestArchivesMessage}
            </div>
          )}
          <table className="table table-hover table-light table-striped">
            <thead>
            <tr>
              <th className="text-center">{locales('tables.row')}</th>
              <th onClick={() => this.sortTable('cafeName')} className="text-center pointer">
                <i
                  name="cafeName"
                  className={generateClassName('cafeName', this.state.sortedColumn, sortType)}
                />
                {locales('fields.cafe.name')}
              </th>
              <th onClick={() => this.sortTable('fromDate')} className="text-center pointer">
                <i
                  name="fromDate"
                  className={generateClassName('fromDate', this.state.sortedColumn, sortType)}
                />
                {locales('titles.fromTime')}
              </th>
              <th onClick={() => this.sortTable('toDate')} className="text-center pointer">
                <i
                  name="toDate"
                  className={generateClassName('toDate', this.state.sortedColumn, sortType)}
                />
                {locales('labels.to.date')}
              </th>
              <th onClick={() => this.sortTable('createdAt')} className="text-center pointer">
                <i
                  name="createdAt"
                  className={generateClassName('createdAt', this.state.sortedColumn, sortType)}
                />
                {locales('tables.createdAt')}
              </th>
              <th className="text-center">{locales('tables.status')}</th>
              <th className="text-center"></th>
            </tr>
            </thead>
            <tbody>
            {cafeDiscountRequestArchivesList || cafeDiscountRequestsList ? (
              (!this.props.fromArchive ? cafeDiscountRequestsList : cafeDiscountRequestArchivesList).map(
                (cafeDiscountRequest, index) => (
                  <tr key={cafeDiscountRequest.id}>
                    <td className="text-center">{(pageNumber - 1) * pageSize + index + 1}</td>
                    <td className="text-center">{cafeDiscountRequest.cafeName}</td>
                    <td className="text-center">{cafeDiscountRequest.fromDate}</td>
                    <td className={`text-center`}>{cafeDiscountRequest.toDate}</td>
                    <td className={`text-center`}>{cafeDiscountRequest.createdAt}</td>
                    <td className={`text-center ${this.renderStatusColors(cafeDiscountRequest.status)}`}>
                      {enumHelper.convertEnumValueToTitle(
                        ENUMS.CAFE_DISCOUNT_STATUS.list,
                        cafeDiscountRequest.status,
                      )}
                    </td>
                    <td className={`text-center`}>
                      <ShowForPermission
                        permission={ENUMS.PERMISSIONS.values.VIEW_CAFE_DISCOUNTS_REQUESTED_LIST}
                      >
                        <i
                          onClick={() => this.displayCafeDiscountRequestModal(cafeDiscountRequest.id)}
                          title={locales('titles.cafeDiscountRequestDetails')}
                          className="text-center far fa-info-circle text-success pointer"
                        />
                      </ShowForPermission>
                    </td>
                  </tr>
                ),
              )
            ) : (
              <tr className="col-12 text-center">
                <td className="alert alert-info" colSpan={12}>
                  {locales('alerts.noRecord')}
                </td>
              </tr>
            )}
            </tbody>
          </table>
          {this.state.cafeDiscountRequestOpen && (
            <CafeDiscountRequestDetails
              isOpen={this.state.cafeDiscountRequestOpen}
              cafeDiscountRequestId={this.state.selectedCafeDiscountRequestId}
              isFromArchive={this.props.history.location.pathname.includes('requests') ? true : false}
              closeModal={this.closeCafeDiscountRequestModal}
              buildSearchQuery={this.props.buildSearchQuery}
              pageSize={this.props.pageSize}
              pageNumber={this.props.pageNumber}
            />
          )}
        </Spin>
      </>
    );
  }
}

const mapStateToProps = state => {
  return {
    cafeDiscountRequestsList: state.cafeDiscountsReducer.cafeDiscountRequestsList,
    cafeDiscountRequests: state.cafeDiscountsReducer.cafeDiscountRequests,
    cafeDiscountRequestsFailed: state.cafeDiscountsReducer.cafeDiscountRequestsFailed,
    cafeDiscountRequestsError: state.cafeDiscountsReducer.cafeDiscountRequestsError,
    cafeDiscountRequestsMessage: state.cafeDiscountsReducer.cafeDiscountRequestsMessage,
    cafeDiscountRequestsLoading: state.cafeDiscountsReducer.cafeDiscountRequestsLoading,

    cafeDiscountRequestArchivesList: state.cafeDiscountsReducer.cafeDiscountRequestArchivesList,
    cafeDiscountRequestArchives: state.cafeDiscountsReducer.cafeDiscountRequestArchives,
    cafeDiscountRequestArchivesFailed: state.cafeDiscountsReducer.cafeDiscountRequestArchivesFailed,
    cafeDiscountRequestArchivesError: state.cafeDiscountsReducer.cafeDiscountRequestArchivesError,
    cafeDiscountRequestArchivesMessage: state.cafeDiscountsReducer.cafeDiscountRequestArchivesMessage,
    cafeDiscountRequestArchivesLoading: state.cafeDiscountsReducer.cafeDiscountRequestArchivesLoading,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    fetchAllCafeDiscountRequests: query => dispatch(cafeDiscountActions.fetchAllCafeDiscountRequests(query)),
    fetchAllCafeDiscountRequestArchives: query =>
      dispatch(cafeDiscountActions.fetchAllCafeDiscountRequestArchives(query)),
  };
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(CafeDiscountRequestsTable),
);
